import digestMessage from '@/util/digest-message'

import usePageDataLayer from './use-page-data-layer'

const handlePageMessage = async (
  { selector, context, trigger },
  pushMessage
) => {
  if (/^TopBanner\/Carousel.banner#\d+$/i.test(selector)) {
    pushMessage({
      event: { click: 'select_promotion', view: 'view_promotion' }[trigger],
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.banner.id.toString(),
            item_name: context.banner.name,
            coupon: 'none',
            currency: 'THB',
            discount: 'none',
            index: 'none',
            item_brand: 'none',
            item_category: 'none',
            item_category2: 'none',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: 'top_banner',
            item_variant: 'none',
            price: 'none',
            quantity: 1,
            promotion_name: context.banner.name,
            promotion_id: context.banner.name,
            creative_name: context.banner.name,
            creative_slot: 'top',
            location_id:
              context.topBanners.findIndex(
                banner => banner.id === context.banner.id
              ) + 1,
          },
        ],
      },
    })
  }

  if (/^ShortcutMenu\/\[MenuItem\]#\d+$/i.test(selector)) {
    pushMessage({
      event: 'shortcut_menu',
      page_group: 'homepage',
      shortcut_menu: context.item.name,
    })
  }

  if (/^ServiceBanner\/Grid.banner#\d+$/i.test(selector)) {
    pushMessage({
      event: 'service_card',
      page_group: 'homepage',
      section_name: 'ทรู คอร์ปอเรชั่น ผู้นำดิจิทัลไลฟ์สไตล์ครบวงจร',
      card_name: context.banner.name,
    })
  }

  if (/^MobilePackage\/Tabs.tab#.+$/i.test(selector)) {
    pushMessage({
      event: 'package_type_menu',
      page_group: 'homepage',
      package_type: context.tab.title,
    })
  }

  if (/^MobilePackage\/\[PostpaidCard\]#.+$/i.test(selector)) {
    let discount =
      parseFloat(context.pack.priceplan.normalPrice) -
      parseFloat(context.pack.priceplan.sellingPrice)

    pushMessage({
      event: 'view_item_list',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.pack.id.split(':').slice(1).join(':'),
            item_name: context.pack.name,
            coupon: 'none',
            currency: 'THB',
            discount: isNaN(discount) ? 'none' : discount,
            index: context.mobilePackages[0].packages.findIndex(
              pack => pack.id === context.pack.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: 'SIM|Post-Paid',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant: 'none',
            price: parseFloat(context.pack.priceplan.sellingPrice),
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^MobilePackage\/\[PostpaidCard.button#1\]#.+$/i.test(selector)) {
    let discount =
      parseFloat(context.pack.priceplan.normalPrice) -
      parseFloat(context.pack.priceplan.sellingPrice)

    pushMessage({
      event: 'card_more_detail',
      page_group: 'homepage',
      button: context.pack.priceplan.buttonName1,
      item_id: context.pack.id.split(':').slice(1).join(':'),
      item_name: context.pack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.mobilePackages[0].packages.findIndex(
        pack => pack.id === context.pack.id
      ),
      item_brand: 'none',
      item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: 'none',
      price: parseFloat(context.pack.priceplan.sellingPrice),
    })
  }

  if (/^MobilePackage\/\[PostpaidCard.button#2\]#.+$/i.test(selector)) {
    let discount =
      parseFloat(context.pack.priceplan.normalPrice) -
      parseFloat(context.pack.priceplan.sellingPrice)

    pushMessage({
      event: 'select_item',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.pack.id.split(':').slice(1).join(':'),
            item_name: context.pack.name,
            coupon: 'none',
            currency: 'THB',
            discount: isNaN(discount) ? 'none' : discount,
            index: context.mobilePackages[0].packages.findIndex(
              pack => pack.id === context.pack.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: 'SIM|Post-Paid',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant: 'none',
            price: parseFloat(context.pack.priceplan.sellingPrice),
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^MobilePackage\/\[PrepaidCard\]#.+$/i.test(selector)) {
    pushMessage({
      event: 'view_item_list',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.pack.id.split(':').slice(1).join(':'),
            item_name: context.pack.name,
            coupon: 'none',
            currency: 'THB',
            discount: 'none',
            index: context.mobilePackages[1].packages.findIndex(
              pack => pack.id === context.pack.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: 'SIM|Pre-Paid',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant:
              context.pack.priceplan.data +
              'บาท/' +
              context.pack.priceplan.dataUnit +
              '|none|none',
            price: parseFloat(context.pack.priceplan.price),
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^MobilePackage\/\[PrepaidCard.button#1\]#.+$/i.test(selector)) {
    pushMessage({
      event: 'card_more_detail',
      page_group: 'homepage',
      button: context.pack.priceplan.buttonName1,
      item_id: context.pack.id.split(':').slice(1).join(':'),
      item_name: context.pack.name,
      coupon_name: 'none',
      discount: 'none',
      index: context.mobilePackages[1].packages.findIndex(
        pack => pack.id === context.pack.id
      ),
      item_brand: 'none',
      item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant:
        context.pack.priceplan.data +
        'บาท/' +
        context.pack.priceplan.dataUnit +
        '|none|none',
      price: parseFloat(context.pack.priceplan.price),
    })
  }

  if (/^MobilePackage\/\[PrepaidCard.button#2\]#.+$/i.test(selector)) {
    pushMessage({
      event: 'select_item',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.pack.id.split(':').slice(1).join(':'),
            item_name: context.pack.name,
            coupon: 'none',
            currency: 'THB',
            discount: 'none',
            index: context.mobilePackages[1].packages.findIndex(
              pack => pack.id === context.pack.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: 'SIM|Pre-Paid',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant:
              context.pack.priceplan.data +
              'บาท/' +
              context.pack.priceplan.dataUnit +
              '|none|none',
            price: parseFloat(context.pack.priceplan.price),
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^MobilePackage\/\[ExtraCard\]#.+$/i.test(selector)) {
    pushMessage({
      event: 'view_item_list',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.pack.id.split(':').slice(1).join(':'),
            item_name: context.pack.name,
            coupon: 'none',
            currency: 'THB',
            discount: 'none',
            index: context.mobilePackages[2].packages.findIndex(
              pack => pack.id === context.pack.id
            ),
            item_brand: 'none',
            item_category:
              (context.pack.priceplan.gtmL1Department ??
                '1_Telecomunication (Telco)') +
              '|' +
              (context.pack.priceplan.gtmL2Category ?? 'Mobile & Gadgets'),
            item_category2:
              (context.pack.priceplan.gtmL3SubCategory ?? 'SIM') +
              '|' +
              (context.pack.priceplan.gtmL4Class ?? 'Extra Package'),
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant:
              context.pack.priceplan.data.replace(/\//g, '|') +
              '|' +
              context.pack.priceplan.priceplanType,
            price: parseFloat(context.pack.priceplan.price),
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^MobilePackage\/\[ExtraCard.button\]#.+$/i.test(selector)) {
    let allItems = []
    context.mobilePackages[2].packages.map((pack, index) => {
      if (pack.id === context.pack.id) {
        allItems.push({
          item_id: pack.id.split(':').slice(1).join(':'),
          item_name: pack.name,
          coupon: 'none',
          currency: 'THB',
          discount: 'none',
          index: index,
          item_brand: 'none',
          item_category:
            (pack.priceplan.gtmL1Department ?? '1_Telecomunication (Telco)') +
            '|' +
            (pack.priceplan.gtmL2Category ?? 'Mobile & Gadgets'),
          item_category2:
            (pack.priceplan.gtmL3SubCategory ?? 'SIM') +
            '|' +
            (pack.priceplan.gtmL4Class ?? 'Extra Package'),
          item_category3: 'none',
          item_category4: 'none',
          item_category5: 'none',
          item_list_id: 'none',
          item_list_name: context.header.name,
          item_variant:
            pack.priceplan.data.replace(/\//g, '|') +
            '|' +
            pack.priceplan.priceplanType,
          price: 'none',
          quantity: 1,
        })
      }
    })

    pushMessage({
      event: 'select_item',
      page_group: 'homepage',
      ecommerce: {
        items: allItems,
      },
    })
  }

  if (/^MobilePackage\/MobilePackage.viewAllButton#.+$/i.test(selector)) {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'view_all',
      section_name: {
        postpaid: 'postpaid_package',
        prepaid: 'prepaid_package',
        extra: 'extra_package',
      }[context.tab.type],
    })
  }

  if (/^HighlightBanner\/Grid.banner#\d+$/i.test(selector)) {
    pushMessage({
      event: { click: 'select_item', view: 'view_item_list' }[trigger],
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.banner.id.toString(),
            item_name: 'none',
            coupon: 'none',
            currency: 'THB',
            discount: 'none',
            index: context.highlightBanners.findIndex(
              banner => banner.id === context.banner.id
            ),
            item_brand: 'none',
            item_category: 'none',
            item_category2: 'none',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: 'highlight_banner',
            item_variant: 'none',
            price: 'none',
            quantity: 1,
            promotion_name: 'none',
            promotion_id: 'none',
            creative_name: context.banner.name,
            creative_slot: 'highlight_banner',
            location_id: context.highlightBanners.findIndex(
              banner => banner.id === context.banner.id
            ),
          },
        ],
      },
    })
  }

  if (/^DeviceShelf\/\[Card\]#\d+$/i.test(selector)) {
    let price = parseFloat(context.device.priceMin)
    let discount = parseFloat(context.device.discount)
    let l4name = context.device.name.indexOf('i') === 0 ? 'Apple' : 'Android'
    pushMessage({
      event: 'view_item_list',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.device.idTruestoreDevice,
            item_name: context.device.name,
            coupon: 'none',
            currency: 'THB',
            discount: isNaN(discount) ? 'none' : discount,
            index: context.deviceManagements.findIndex(
              device => device.id === context.device.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: 'Phone|' + l4name,
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant: 'none',
            price: isNaN(price) ? 'none' : price,
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^DeviceShelf\/\[Card.button\]#\d+$/i.test(selector)) {
    let price = parseFloat(context.device.priceMin)
    let discount = parseFloat(context.device.discount)
    let l4name = context.device.name.indexOf('i') === 0 ? 'Apple' : 'Android'
    pushMessage({
      event: 'select_item',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.device.idTruestoreDevice,
            item_name: context.device.name,
            coupon: 'none',
            currency: 'THB',
            discount: isNaN(discount) ? 'none' : discount,
            index: context.deviceManagements.findIndex(
              device => device.id === context.device.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: 'Phone|' + l4name,
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant: 'none',
            price: isNaN(price) ? 'none' : price,
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^DeviceShelf\/DeviceShelf.viewAllButton$/i.test(selector)) {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'view_all',
      section_name: context.header.name,
    })
  }

  if (/^IotShelf\/\[Card\]#\d+$/i.test(selector)) {
    let price = parseFloat(context.device.priceMin)
    let category2_1 = 'Phone Accessory'
    let category2_2 = 'none'
    if (context.device.name.indexOf('UAG') > -1) {
      category2_1 = 'Phone Case'
      category2_2 = 'Phone Case'
    } else if (context.device.name.indexOf('AirPods') > -1) {
      category2_2 = 'Apple Accessory'
    } else {
      category2_2 = 'Other Mobile/Gadget'
    }

    pushMessage({
      event: 'view_item_list',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.device.idTruestoreDevice,
            item_name: context.device.name,
            coupon: 'none',
            currency: 'THB',
            discount: context.device.discountPercent,
            index: context.iotManagements.findIndex(
              device => device.id === context.device.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: category2_1 + '|' + category2_2,
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant: 'none',
            price: isNaN(price) ? 'none' : price,
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^IotShelf\/\[Card.button\]#\d+$/i.test(selector)) {
    let price = parseFloat(context.device.priceMin)
    let discount = parseFloat(context.device.discount)
    let category2_1 = 'Phone Accessory'
    let category2_2 = 'none'
    if (context.device.name.indexOf('UAG') > -1) {
      category2_1 = 'Phone Case'
      category2_2 = 'Phone Case'
    } else if (context.device.name.indexOf('AirPods') > -1) {
      category2_2 = 'Apple Accessory'
    } else {
      category2_2 = 'Other Mobile/Gadget'
    }
    pushMessage({
      event: 'select_item',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.device.idTruestoreDevice,
            item_name: context.device.name,
            coupon: 'none',
            currency: 'THB',
            discount: isNaN(discount) ? 'none' : discount,
            index: context.iotManagements.findIndex(
              device => device.id === context.device.id
            ),
            item_brand: 'none',
            item_category: '1_Telecomunication (Telco)|Mobile & Gadgets',
            item_category2: category2_1 + '|' + category2_2,
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant: 'none',
            price: isNaN(price) ? 'none' : price,
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^IotShelf\/DeviceShelf.viewAllButton$/i.test(selector)) {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'view_all',
      section_name: context.header.name,
    })
  }

  if (/^InternetPackage\/\[Card\]#.+$/i.test(selector)) {
    let discount =
      parseFloat(context.pack.price) - parseFloat(context.pack.priceSpecial)
    pushMessage({
      event: 'view_item_list',
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.pack.id.split(':').slice(1).join(':'),
            item_name: context.pack.name,
            coupon: 'none',
            currency: 'THB',
            discount: isNaN(discount) ? 'none' : discount,
            index: context.internetPackages[0].packages.findIndex(
              pack => pack.id === context.pack.id
            ),
            item_brand: 'none',
            item_category:
              (context.pack.gtmL1Department ?? '1_Telecomunication (Telco)') +
              '|' +
              (context.pack.gtmL2Category ?? 'Home Internet'),
            item_category2:
              (context.pack.gtmL3SubCategory ?? 'Fiber Internet') +
              '|' +
              (context.pack.gtmL4Class ?? 'True Online'),
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: context.header.name,
            item_variant:
              context.pack.download +
              context.pack.downloadUnit +
              '/' +
              context.pack.upload +
              context.pack.uploadUnit +
              '|none|none',
            price: parseFloat(context.pack.priceSpecial),
            quantity: 1,
          },
        ],
      },
    })
  }

  if (/^InternetPackage\/\[Card.button#1\]#.+$/i.test(selector)) {
    let serviceBy = context.pack.serviceType
      ? context.pack.serviceType.serviceButton
        ? context.pack.serviceType.serviceButton.serviceName
        : 'tele'
      : 'tele'
    let event =
      serviceBy === 'self'
        ? 'initiate_tol_self_service'
        : 'initiate_tol_none_self_service'

    pushMessage({
      event: event,
      button: context.pack.serviceBy
        ? context.pack.serviceBy.buttonOnCard
        : 'none',
      product_name: context.pack.name,
      product_detail: `${context.pack.download} ${context.pack.downloadUnit}/${context.pack.upload} ${context.pack.uploadUnit}`,
      product_price: parseFloat(context.pack.priceSpecial),
      section_name: context.header.name,
      service_by: serviceBy,
      pack_shelf: context.pack.packShelf ?? 'MASS',
      page_group: 'homepage',
    })
  }

  if (/^InternetPackage\/\[Card.button#2\]#.+$/i.test(selector)) {
    let discount =
      parseFloat(context.pack.price) - parseFloat(context.pack.priceSpecial)

    let allItems = []
    context.internetPackages[0].packages.map((pack, index) => {
      if (pack.id === context.pack.id) {
        allItems.push({
          item_id: pack.id.split(':').slice(1).join(':'),
          item_name: pack.name,
          coupon: 'none',
          currency: 'THB',
          discount: isNaN(discount) ? 'none' : discount,
          index: index,
          item_brand: 'none',
          item_category:
            (pack.gtmL1Department ?? '1_Telecomunication (Telco)') +
            '|' +
            (pack.gtmL2Category ?? 'Home Internet'),
          item_category2:
            (pack.gtmL3SubCategory ?? 'Fiber Internet') +
            '|' +
            (pack.gtmL4Class ?? 'True Online'),
          item_category3: 'none',
          item_category4: 'none',
          item_category5: 'none',
          item_list_id: 'none',
          item_list_name: context.header.name,
          item_variant: `${context.pack.download} ${context.pack.downloadUnit}/${context.pack.upload} ${context.pack.uploadUnit}|none|none`,
          price: parseFloat(context.pack.priceSpecial),
          quantity: 1,
        })
      }
    })
    pushMessage({
      event: 'select_item',
      page_group: 'homepage',
      ecommerce: {
        items: allItems,
      },
    })
  }

  if (selector === 'InternetPackage/ContactModal.termsButton') {
    let discount =
      parseFloat(context.selectedPack.price) -
      parseFloat(context.selectedPack.priceSpecial)

    pushMessage({
      event: 'card_more_detail',
      page_group: 'homepage',
      button: 'terms_and_conditions',
      item_id: context.selectedPack.id.split(':').slice(1).join(':'),
      item_name: context.selectedPack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.internetPackages[0].packages.findIndex(
        pack => pack.id === context.selectedPack.id
      ),
      item_brand: 'none',
      item_category:
        (context.selectedPack.gtmL1Department ?? '1_Telecomunication (Telco)') +
        '|' +
        (context.selectedPack.gtmL2Category ?? 'Home Internet'),
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: `${context.pack.download} ${context.pack.downloadUnit}/${context.pack.upload} ${context.pack.uploadUnit}|none|none`,
      price: parseFloat(context.selectedPack.priceSpecial),
    })
  }

  if (selector === 'InternetPackage/ContactModal.retryButton') {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'retry',
      section_name: context.header.name,
    })
  }

  if (selector === 'InternetPackage/ContactModal.doneButton') {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'back',
      section_name: context.header.name,
    })
  }

  if (selector === 'InternetPackage/ContactModal.alreadyInQueueErrorForm') {
    let discount =
      parseFloat(context.selectedPack.price) -
      parseFloat(context.selectedPack.priceSpecial)

    pushMessage({
      event: 'register_result',
      page_group: 'homepage',
      button: 'none',
      item_id: context.selectedPack.id.split(':').slice(1).join(':'),
      item_name: context.selectedPack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.internetPackages[0].packages.findIndex(
        pack => pack.id === context.selectedPack.id
      ),
      item_brand: 'none',
      item_category:
        (context.selectedPack.gtmL1Department ?? '1_Telecomunication (Telco)') +
        '|' +
        (context.selectedPack.gtmL2Category ?? 'Home Internet'),
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: 'none',
      price: parseFloat(context.selectedPack.priceSpecial),
      lead_id: 'none',
      hash_email: 'none',
      hash_phone_number: await digestMessage(context.inputs.phoneNumber),
      zip_code: 'none',
      register_result: 'error',
    })
  }

  if (selector === 'InternetPackage/ContactModal.unknownErrorForm') {
    let discount =
      parseFloat(context.selectedPack.price) -
      parseFloat(context.selectedPack.priceSpecial)

    pushMessage({
      event: 'register_result',
      page_group: 'homepage',
      button: 'none',
      item_id: context.selectedPack.id.split(':').slice(1).join(':'),
      item_name: context.selectedPack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.internetPackages[0].packages.findIndex(
        pack => pack.id === context.selectedPack.id
      ),
      item_brand: 'none',
      item_category:
        (context.selectedPack.gtmL1Department ?? '1_Telecomunication (Telco)') +
        '|' +
        (context.selectedPack.gtmL2Category ?? 'Home Internet'),
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: 'none',
      price: parseFloat(context.selectedPack.priceSpecial),
      lead_id: 'none',
      hash_email: 'none',
      hash_phone_number: await digestMessage(context.inputs.phoneNumber),
      zip_code: 'none',
      register_result: 'error',
    })
  }

  if (selector === 'InternetPackage/ContactModal@submitFormSuccess') {
    let discount =
      parseFloat(context.selectedPack.price) -
      parseFloat(context.selectedPack.priceSpecial)

    pushMessage({
      event: 'register',
      page_group: 'homepage',
      button: 'submit',
      item_id: context.selectedPack.id.split(':').slice(1).join(':'),
      item_name: context.selectedPack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.internetPackages[0].packages.findIndex(
        pack => pack.id === context.selectedPack.id
      ),
      item_brand: 'none',
      item_category:
        (context.selectedPack.gtmL1Department ?? '1_Telecomunication (Telco)') +
        '|' +
        (context.selectedPack.gtmL2Category ?? 'Home Internet'),
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: 'none',
      price: parseFloat(context.selectedPack.priceSpecial),
    })
  }

  if (selector === 'InternetPackage/ConsentModal.successForm') {
    let discount =
      parseFloat(context.selectedPack.price) -
      parseFloat(context.selectedPack.priceSpecial)

    pushMessage({
      event: 'register_result',
      page_group: 'homepage',
      button: 'none',
      item_id: context.selectedPack.id.split(':').slice(1).join(':'),
      item_name: context.selectedPack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.internetPackages[0].packages.findIndex(
        pack => pack.id === context.selectedPack.id
      ),
      item_brand: 'none',
      item_category:
        (context.selectedPack.gtmL1Department ?? '1_Telecomunication (Telco)') +
        '|' +
        (context.selectedPack.gtmL2Category ?? 'Home Internet'),
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: 'none',
      price: parseFloat(context.selectedPack.priceSpecial),
      lead_id: 'none',
      hash_email: 'none',
      hash_phone_number: await digestMessage(context.contactInputs.phoneNumber),
      zip_code: 'none',
      register_result: 'success',
    })
  }

  if (selector === 'InternetPackage/ConsentModal.doneButton') {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'done',
      section_name: context.header.name,
    })
  }

  if (selector === 'InternetPackage/ConsentModal@submitFormSuccess') {
    let discount =
      parseFloat(context.selectedPack.price) -
      parseFloat(context.selectedPack.priceSpecial)

    pushMessage({
      event: 'consent',
      page_group: 'homepage',
      button: context.status,
      item_id: context.selectedPack.id.split(':').slice(1).join(':'),
      item_name: context.selectedPack.name,
      coupon_name: 'none',
      discount: isNaN(discount) ? 'none' : discount,
      index: context.internetPackages[0].packages.findIndex(
        pack => pack.id === context.selectedPack.id
      ),
      item_brand: 'none',
      item_category:
        (context.selectedPack.gtmL1Department ?? '1_Telecomunication (Telco)') +
        '|' +
        (context.selectedPack.gtmL2Category ?? 'Home Internet'),
      item_list_id: 'none',
      item_list_name: context.header.name,
      item_variant: 'none',
      price: parseFloat(context.selectedPack.priceSpecial),
      lead_id: 'none',
      hash_email: 'none',
      hash_phone_number: await digestMessage(context.contactInputs.phoneNumber),
      zip_code: 'none',
      register_result: 'success',
      consent_result: 'success',
    })
  }

  if (/^InternetPackage\/InternetPackage.viewAllButton#.+$/i.test(selector)) {
    pushMessage({
      event: 'call_to_action',
      page_group: 'homepage',
      button: 'View all',
      section_name: context.header.name,
    })
  }

  if (selector === 'BottomBanner/Banner') {
    pushMessage({
      event: { click: 'select_promotion', view: 'view_promotion' }[trigger],
      page_group: 'homepage',
      ecommerce: {
        items: [
          {
            item_id: context.banner.id.toString(),
            item_name: context.banner.name,
            coupon: 'none',
            currency: 'THB',
            discount: 'none',
            index: 'none',
            item_brand: 'none',
            item_category: 'none',
            item_category2: 'none',
            item_category3: 'none',
            item_category4: 'none',
            item_category5: 'none',
            item_list_id: 'none',
            item_list_name: 'bottom_banner',
            item_variant: 'none',
            price: 'none',
            quantity: 1,
            promotion_name: context.banner.name,
            promotion_id: context.banner.name,
            creative_name: context.banner.name,
            creative_slot: 'bottom',
            location_id: context.banner.position,
          },
        ],
      },
    })
  }
}

const useHomePageDataLayer = () => {
  let { createHandler, createScopeProps } = usePageDataLayer()
  let handleMessage = createHandler(handlePageMessage)
  return { handleMessage, createScopeProps }
}

export default useHomePageDataLayer
